import { DateRangeOptional } from 'fabscale-app/models/date-range';
import { serializeDateRange } from 'fabscale-app/utilities/utils/serialize-date-range';

export default function serializeDateRangeHelper(dateRange: DateRangeOptional) {
  return serializeDateRange(dateRange);
}
